<template>
    <div @click.stop class="image_saver_task">
        <div class="image_saver_task_title">
            <div class="image_saver_task_name">{{ $t('language.imageSaver.recentlySaved') }}</div>
            <div @click="clearTask" class="image_saver_task_clear">{{ $t('language.imageSaver.clearHistory') }}</div>
        </div>
        <div class="image_saver_task_body">
            <div v-if="tasks.length == 0" class="image_saver_task_no">
                <img src="../../assets/images/imageSaver/taskNo.svg" />
                <div>{{ $t('language.imageSaver.noTask') }}</div>
            </div>
            <div v-if="tasks.length != 0" class="image_saver_task_items">
                <div v-for="(task, index) of tasks" :key="task.id" class="image_saver_task_item"
                    :class="'image_saver_' + task.status">
                    <img :src="task.fromData.pre ? task.fromData.pre : task.fromData.url" @error="previewError($event)" :class="'imagesaver_' + task.fromType + ' imagesaver_' + task.fromData.type" />
                    <div v-if="task.fromData.type == 'all'" class="image_saver_task_all"></div>
                    <div v-if="task.fromData.type == 'all'" class="image_saver_task_detail">
                        <div class="detail_success">
                            <img src="../../assets/images/imageSaver/insTaskHover.svg"/>
                            <span>{{ decodeDetail(task, 'success') + decodeDetail(task, 'skip') }}</span>
                        </div>
                        <div class="detail_error">{{ $t('language.common.failed') }}: {{ decodeDetail(task, 'error') }}</div>
                    </div>
                    <div v-if="task.fromData.type == 'video'" class="image_saver_task_video"></div>
                    <div v-if="task.status == 'create' || task.status == 'run'" class="image_saver_task_prog">
                        <el-progress type="circle" :width="14" :stroke-width="7" :percentage="decodePercentage(task)"
                            :show-text="false" define-back-color="rgba(0,0,0,0.3)" color="#FFF"
                            stroke-linecap="butt"></el-progress>
                    </div>
                    <div v-if="task.status == 'error'" class="image_saver_task_error"></div>
                    <div @click="cancelTask(index)" class="image_saver_task_cancel">{{ $t('language.imageSaver.cancel') }}</div>
                    <div @click="viewTask(task)" class="image_saver_task_view">{{ $t('language.imageSaver.view') }}</div>
                    <div @click="retryTask(index)" class="image_saver_task_retry">{{ $t('language.imageSaver.retry') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";

export default {
    name: "imageSaverTask",
    props: ['tasks', 'retryTask', 'cancelTask', 'clearTask'],
    data() {
        return {
            // 这是一个透明图片，啥都没有
            previewErrorImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVFRTM3MDUyMThGRDExRUZCRUQ4Q0MyNzRERkVFM0UzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVFRTM3MDUzMThGRDExRUZCRUQ4Q0MyNzRERkVFM0UzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUVFMzcwNTAxOEZEMTFFRkJFRDhDQzI3NERGRUUzRTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUVFMzcwNTExOEZEMTFFRkJFRDhDQzI3NERGRUUzRTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5Exga6AAAAFUlEQVR42mL8//8/AwgwMUABQIABADAGAwGo78J/AAAAAElFTkSuQmCC',
        };
    },
    computed: {
        // 已完成的任务计数
        finishTaskCount() {
            var count = 0;
            for (var i = 0; i < this.tasks.length; i++) {
                var status = this.tasks[i].status;
                if (status == 'success' || status == 'error') {
                    count++;
                }
            }
            return count;
        }
    },
    methods: {
        // 预览失败处理
        previewError(event) {
            event.target.src = this.previewErrorImg;
        },
        // 解析详情
        decodeDetail(task, type) {
            if (task.msg.indexOf("{") == 0) {
                return JSON.parse(task.msg)[type];
            } else {
                return 0;
            }
        },
        // 解析进度
        decodePercentage(task) {
            var status = task.status;
            if (status == 'create') {
                return 0;
            } else if (status == 'run') {
                var msg = task.msg;
                if (msg.indexOf("{") == 0) {
                    // JSON
                    return JSON.parse(msg).prog;
                } else {
                    // 纯数字
                    return parseInt(msg);
                }
            } else if (status == 'success') {
                return 100;
            } else if (status == 'error') {
                return 100;
            } else {
                return 0;
            }
        },
        // 跳转到目标位置
        viewTask(task) {
            taskListUtils.imageSaverRequest("/jumpToSource", { id: task.id }, res => {
                if (res.code == 200) {
                    // 确定云盘下标
                    var index = null;
                    var drives = this.$store.getters.getUsersDrives;
                    for (var i=0; i<drives.length; i++) {
                        if (drives[i].id == res.data.tokenId) {
                            index = i;
                            break;
                        }
                    }
                    // 选择该云盘
                    if (index) {
                        this.$parent.$parent.$refs.leftBanner.clickCurrent = index;
                    }
                    // 取消“图片保存”的选择
                    this.$parent.$parent.$refs.leftBanner.isSelectImageSaver = false;
                    // 跳转路径处理
                    var data = [];
                    var nodes = JSON.parse(res.data.folderName);
                    // 使用最新的云盘名称
                    nodes[nodes.length-1].name = drives[index].name;
                    for (var i=0; i<nodes.length; i++) {
                        var node = {};
                        node.fileName = nodes[i].name;
                        node.tokenId = res.data.tokenId;
                        node.cloudType = res.data.cloudType;
                        node.fileId = nodes[i].id;
                        data.push(node);
                    }
                    commonUtils.encapsulationPath(data);
                    // 跳转到云盘管理
                    res.data.folderName = nodes[0].name;
                    this.$router.push({
                        name: "cloudExploer",
                        query: res.data
                    });
                }
            });
        },
    }
};
</script>

<style>
/* 任务弹窗 */
.image_saver_task {
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* 标题 */
.image_saver_task_title {
    height: 58px;
    padding: 0 20px;
    background: #5562B4;
    box-sizing: border-box
}

/* 标题文字 */
.image_saver_task_name {
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 58px;
    display: inline-block;
}

/* 清理 */
.image_saver_task_clear {
    font-size: 14px;
    color: #FFFFFF;
    float: right;
    line-height: 58px;
    cursor: pointer;
}

/* 主体 */
.image_saver_task_body {
    flex: 1;
    position: relative;
    overflow: auto;
}

/* 滚动条 */
.image_saver_task_body::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}

.image_saver_task_body::-webkit-scrollbar-thumb {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #BECAE4;
    min-height: 100px;
}

/* 没有任务图标和文字 */
.image_saver_task_no {
    width: 200px;
    height: 147px;
    text-align: center;
    position: absolute;
    margin: auto;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* 没有任务文字 */
.image_saver_task_no>div {
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #C1CBE3;
}

/* 任务列表 */
.image_saver_task_items {
    padding: 15px;
    padding-right: 0;
}

/* 清除高度塌陷 */
.image_saver_task_items::after {
    content: "";
    display: block;
    clear: both;
}

/* 单个任务 */
.image_saver_task_item {
    padding: 5px;
    margin: 5px;
    background-color: #FFF;
    float: left;
    position: relative;
    box-shadow: 0px 0px 4px 0px rgba(87, 94, 136, 0.3);
}

/* 任务预览图 */
.image_saver_task_item>img {
    width: 100px;
    height: 100px;
}

.image_saver_task_item>img.imagesaver_web {
    object-fit: scale-down;
}

.image_saver_task_item>img.imagesaver_instagram {
    object-fit: cover;
}

.image_saver_task_item>img.imagesaver_google {
    object-fit: contain;
}

.image_saver_task_item>img.imagesaver_instagram.imagesaver_all {
    border-radius: 50px;
}

/* 任务图标 */
.image_saver_task_all {
    width: 16px;
    height: 16px;
    background-image: url("../../assets/images/imageSaver/insTask.svg");
    position: absolute;
    z-index: 1;
    bottom: 6px;
    left: 6px;
}

.image_saver_task_item:hover>.image_saver_task_all {
    display: none;
}

/* 任务详情 */
.image_saver_task_detail {
    display: none;
    width: 100%;
    height: 26px;
    color: #FFF;
    padding-top: 5px;
    text-align: center;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.7);
    position: absolute;
    z-index: 3;
    left: 0px;
    bottom: 0px;
}

/* Instagram成功数文字对齐 */
.image_saver_task_detail span {
    vertical-align: middle;
}

/* Instagram成功失败默认不显示 */
.detail_success,
.detail_error {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 5px;
    display: none;
}

/* Instagram成功数 */
.image_saver_success:hover>.image_saver_task_detail,
.image_saver_success:hover>.image_saver_task_detail>.detail_success {
    display: block;
}

/* Instagram失败数 */
.image_saver_error:hover>.image_saver_task_detail,
.image_saver_error:hover>.image_saver_task_detail>.detail_error {
    display: block;
}

/* 视频图标 */
.image_saver_task_video {
    width: 21px;
    height: 21px;
    background-image: url("../../assets/images/imageSaver/typeVideo.svg");
    position: absolute;
    z-index: 1;
    left: 10px;
    top: 10px;
}

/* 进度外框 */
.image_saver_task_prog {
    width: 16.5px;
    height: 16.5px;
    border-radius: 16px;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 0.3);
    position: absolute;
    z-index: 1;
    right: 10px;
    top: 10px;

}

/* 进度百分比 */
.image_saver_task_prog>div {
    margin-top: 1px;
    margin-left: 1px;
}

/* 取消、预览、重试 */
.image_saver_task_cancel,
.image_saver_task_view,
.image_saver_task_retry {
    display: none;
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5);
    background-repeat: no-repeat;
    background-position: 40px 33px;
    padding-top: 65px;
    box-sizing: border-box;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}

/* 可以取消：未开始的任务、正在执行的任务 */
.image_saver_create:hover>.image_saver_task_cancel,
.image_saver_run:hover>.image_saver_task_cancel {
    display: block;
}

/* 成功的可以预览 */
.image_saver_success:hover>.image_saver_task_view {
    display: block;
}

/* 失败的可以重试 */
.image_saver_error:hover>.image_saver_task_retry {
    display: block;
}

/* 取消图标 */
.image_saver_task_cancel {
    background-image: url("../../assets/images/imageSaver/taskCancel.svg");
}

/* 预览图标 */
.image_saver_task_view {
    background-image: url("../../assets/images/imageSaver/taskView.svg");
}

/* 重试图标 */
.image_saver_task_retry {
    background-image: url("../../assets/images/imageSaver/taskRetry.svg");
}

/* 失败图标 */
.image_saver_task_error {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/imageSaver/taskError.svg");
    background-color: rgba(0, 0, 0, 0.5);
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
}

.image_saver_task_item:hover>.image_saver_task_error {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver_task.vue